<template>
  <div>
    <section v-if="this.getTrackingOverride()">
      <label for="tracking-point">How long ago was the last tracking point?</label>
      <select id="tracking-point" name="lastTrackingUpdate" v-model="selected">
        <option value="<2">Less than 2 days</option>
        <option value="2-30">2-30 days</option>
        <option value="30+">30 days +</option>
      </select>
    </section>
    <div v-if="isTooNew()">
      <p>Thanks for letting us know. Rest assured we are still on track to get the parcel delivered on time. We'll send the recipient a delivery window as soon as it's out for delivery.</p>
    </div>
    <div v-if="isEnquirable()">
      <div>
        <p>Thank you for letting us know.</p>
        <p>We will get this escalated to the local team for investigation.</p>
      </div>
      <EscalateEnquiryForm />
    </div>
    <div v-if="isTooOld()">
      <p>Due to the volume of parcels that travel through our network, to ensure that a thorough investigation can take place we do require all enquiries to be submitted within 30 days of sending the parcel.<br/>I am sorry to advise you that as this timeframe has now passed, we would be unable to investigate this for you.</p>
      <p>We would ask that you now follow your standard claims procedure/agreement.</p>
    </div>
  </div>

</template>

<script>
import EscalateEnquiryForm from '../EscalateEnquiryForm'
import trackingJS from '../helpers/tracking.js';

export default {
  mixins: [trackingJS],
  data () {
    return {
      selected: false
    }
  },
  methods: {
    isNextDay() {
      return this.$store.state.tracking.nextDay;
    },
    isTooNew() {
      if (this.getTrackingOverride()) {
        return this.selected === '<2';
      }
      if (this.isReturnBarcode()) {
        return this.getTrackingAge(2, false) === 'NEW';
      }

      return this.isNextDay() ?
          this.getTrackingAge(1, true) === 'NEW' :
          this.getTrackingAge(2, true) === 'NEW';
    },
    isEnquirable() {
      if (this.getTrackingOverride()) {
        return this.selected === '2-30';
      }
      if (this.isReturnBarcode()) {
        return this.getTrackingAge(2, false) === 'MEDIUM';
      }

      return this.isNextDay() ?
          this.getTrackingAge(1, true) === 'MEDIUM' :
          this.getTrackingAge(2, true) === 'MEDIUM';
    },
    isTooOld() {
      if (this.getTrackingOverride()) {
        return this.selected === '30+';
      }
      if (this.isReturnBarcode()) {
        return this.getTrackingAge(2, false) === 'TOO_OLD';
      }
      return this.getTrackingAge(2, true) === 'TOO_OLD';
    }
  },
  components: {
    EscalateEnquiryForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sections/LastTrackingPoint.vue